import React from "react";
import { Icon } from "@iconify/react";
import styles from "./ViewApplication.module.scss";

interface Candidate {
  candidate_id: number;
  full_name: string;
  email: string;
  phone: string;
  cover_letter: string;
  resume_filename: string;
  resume_downloaded: boolean;
  application_status: string;
  created_at: string | null;
  feedback_summary?: string;
  score?: number; 
}

interface Job {
  job_id: number;
  position: string;
  location: string;
  practice: string;
  responsibilities?: string;
  qualifications?: string;
  description?: string;
  status: string;
  deadline: string | null;
}

interface Props {
  candidate: Candidate;
  job: Job | null;
  onBack: () => void;
}

const ViewApplication: React.FC<Props> = ({ candidate, job, onBack }) => {
  const formatDate = (date: string | null) => {
    if (!date) return "N/A";
    const d = new Date(date);
    return `${String(d.getDate()).padStart(2, "0")}-${String(
      d.getMonth() + 1
    ).padStart(2, "0")}-${d.getFullYear()}`;
  };

  console.log("Score",candidate )
  console.log("Summary",candidate?.feedback_summary )
  const feedbackSummaryString = candidate?.feedback_summary ||"";

  const feedbackSummaryArray = feedbackSummaryString
  .split("\n")
  .map(line => line.replace(/^-\s*/, "").trim()) // removes the "-" at start
  .filter((item) => item.trim() !== "");

  return (
    <div className={styles.view__container}>
      <div className={styles.view__card}>
        {/* Header */}
        <div className={styles.header}>
          <div>
            <h2>{candidate?.full_name || "Applicant Name"}</h2>
            <div className={styles.subText}>
              Job ID: {job?.job_id || "N/A"} | Applied For: {job?.position}
            </div>
          </div>
        </div>

        {/* Details Grid */}
        <div className={styles.detailsGrid}>
          <div><Icon icon="mdi:account" width="20" /> {candidate?.full_name}</div>
          <div><Icon icon="ep:map-location" width="20" /> {job?.location || "N/A"}</div>
          <div><Icon icon="mdi:email" width="20" /> {candidate?.email}</div>
          <div><Icon icon="mdi:briefcase" width="20" /> {job?.practice || "N/A"}</div>
          <div><Icon icon="mdi:phone" width="20" /> {candidate?.phone}</div>
          <div><Icon icon="mdi:calendar-check" width="20" /> Status: {candidate?.application_status}</div>
          <div><Icon icon="mdi:calendar-clock" width="20" /> Applied: {formatDate(candidate?.created_at)}</div>
          <div><Icon icon="mdi:clock-alert" width="20" /> Deadline: {formatDate(job?.deadline || null)}</div>
        </div>

        {/* Sections */}
        {candidate?.cover_letter && (
          <div className={styles.longTextBlock}>
            <h4>Cover Letter</h4>
            <p>{candidate?.cover_letter}</p>
          </div>
        )}

         {/* feedback Summary */}
      <div className={styles.longTextBlock}>
      <h4>Feedback Summary</h4>
      <ul className={styles.bulletList}>
        {feedbackSummaryArray.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
      </div>

       {/* Resume Evaluation */}
      {candidate?.score !== undefined && (
        <div className={styles.longTextBlock}>
          <h4>Overall Recommendation</h4>
          <p>
            {candidate?.score > 7.5
              ? "Excellent resume — strongly recommended for hire."
              : candidate?.score > 5
              ? "Good resume — consider for interview."
              : candidate?.score > 2.5
              ? "Average resume — needs further evaluation."
              : "Weak resume — not recommended for hire."}
          </p>
        </div>
      )}

        {/* Actions */}
        <div className={styles.btnWrapper}>
          <button className={styles.backBtn} onClick={onBack}>← Back</button>
          <a
            className={styles.resumeLink}
            href={`${process.env.REACT_APP_API_URL}/applications/${candidate?.candidate_id}/resume`}
            target="_blank"
            rel="noopener noreferrer"
          >
            View Resume
          </a>
        </div>
      </div>
    </div>
  );
};

export default ViewApplication;
